import { IFormantTheme } from "../../../style/IFormantTheme";

export const defaultSpacing = {
    space100: `${100 / 16}em`,
    space60: `${60 / 16}em`,
    space40: `${40 / 16}m`,
    space20: `${20 / 16}em`,
    space15: `${15 / 16}5rem`,
    space10: `${10 / 16}rem`,
    space6: `${6 / 16}rem`,
    space5: `${5 / 16}rem`,
    space2: `${2 / 16}rem`,
};

export const defaultGroupColors = {
    patina: "#738E6A",
    adamantine: "#0495A6",
    mithril: "#76A7DC",
    rhenium: "#494DB3",
    palladium: "#7565AA",
    iron: "#735478",
    copper: "#6D5058",
    electrum: "#996E81",
    gold: "#A18370",
};

export const defaultDataColors = {
    green: "#2EC495",
    mint: "#64d7d4",
    royalBlue: "#20A0FF",
    purple: "#A961E4",
    red: "#EA719D",
    orange: "#F89973",
    yellow: "#F9C36E",
    greenDark: "#2D8376",
    mintDark: "#64d7d4",
    royalBlueDark: "#20A0FF",
    purpleDark: "#564A94",
    redDark: "#7F5072",
    orangeDark: "#94645F",
    yellowDark: "#9A8261",
};

export const DarkPalette: IFormantTheme = {
    spacing: defaultSpacing,
    colors: {
        primary: {
            black: "#000000",
            dark: "#0A0B10",
            dark02: "#171824",
            flagship: "#1C1E2D",
            module: "#2D3855",
            steel01: "#282F45",
            steel02: "#3B4668",
            steel03: "#657197",
            silver: "#BAC4E2",
            white: "#FFFFFF",
        },
        highlights: {
            blue: "#18D2FF",
            royalBlue: "#20A0FF",
            purple: "#A961E4",
            blueIce: "#F0F7FE",
            offWhite: "#F8F9FC",
        },
        severityLevels: {
            green: "#2EC495",
            royalBlue: "#20A0FF",
            purple: "#A961E4",
            orange: "#F89973",
            red: "#EA719D",
        },
        healthStatus: {
            active: "#18D2FF",
            inactive: "#BAC4E2",
            warning: "#A961E4",
            offline: "#F89973",
        },
        groups: defaultGroupColors,
        data: defaultDataColors,
        gradients: {
            g1: "linear-gradient(180deg, #ff72cc 0%, #00e4ff 100%)",
            g2: "linear-gradient(180deg, #cd90ff 0%, #18d2ff 100%)",
            g3: "linear-gradient(180deg, #00efc1 0%, #18d2ff 100%)",
            g4: "linear-gradient(180deg, #ffc794 0%, #18d2ff 100%)",
            g5: "linear-gradient(180deg, #ffa3a1 0%, #18d2ff 100%)",
        },
    },
};

export const LightPalette: IFormantTheme = {
    spacing: defaultSpacing,
    colors: {
        primary: {
            black: "#FFF",
            dark: "#CCC",
            dark02: "#171824",
            flagship: "#0A0B10",
            module: "#E1E6F6",
            steel01: "#F0F4FF",
            steel02: "#CDD4EA",
            steel03: "#99B9DB",
            silver: "#657197",
            white: "#000000",
        },
        highlights: {
            blue: "#1995FC",
            royalBlue: "#20A0FF",
            purple: "#A961E4",
            blueIce: "#01080E",
            offWhite: "#030407",
        },
        severityLevels: {
            green: "#38CE98",
            royalBlue: "#20A0FF",
            purple: "#A961E4",
            orange: "#F89973",
            red: "#EA719D",
        },
        healthStatus: {
            active: "#1995FC",
            inactive: "#BAC4E2",
            warning: "#A961E4",
            offline: "#F89973",
        },
        groups: defaultGroupColors,
        data: defaultDataColors,
        gradients: {
            g1: "linear-gradient(180deg, #ff72cc 0%, #00e4ff 100%)",
            g2: "linear-gradient(180deg, #cd90ff 0%, #1995FC 100%)",
            g3: "linear-gradient(180deg, #00efc1 0%, #1995FC 100%)",
            g4: "linear-gradient(180deg, #ffc794 0%, #1995FC 100%)",
            g5: "linear-gradient(180deg, #ffa3a1 0%, #1995FC 100%)",
        },
    },
};
